module.exports = __webpack_public_path__ + "static/img/link-bg-partnership.9c96f13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/link-bg-partnership.png
// module id = fhIY
// module chunks = 2